if (!window.Eurus.loadedScript.has('product-media.js')) {
  window.Eurus.loadedScript.add('product-media.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductMedia', (settings) => ({
        thumbnailOnMouseDown: false,
        thumbnailOfset: 0,
        thumbnailScrollOfset: 0,
        thumbnailGrabbingClass: '',
        zoomIsOpen: false,
        productMediaIsOpen: '',
        videoExternalListened: false,
        xPosition: 0,
        yPosition: 0,
        imageWidth: 0,
        imageHeight: 0,
        mediaView: 'photos',
        overlayMuted: true,
        init() {
          this.$watch('mediaView', () => this._syncMediaView());
          this.$el.addEventListener('click', (event) => {
            const thumb = event.target.closest('.x-thumbnail');
            if (!thumb || !this.$el.contains(thumb)) return;
            const mediaId = thumb.getAttribute('data-media-id');
            if (!mediaId) return;
            const videoSlide = this.$el.querySelector('.product-media--video[data-media-id="' + mediaId + '"]');
            if (videoSlide) {
              event.preventDefault();
              event.stopPropagation();
              this.setMediaView('video');
              return;
            }
            this.setMediaView('photos');
          }, true);
        },
        setMediaView(view) {
          if (view !== 'photos' && view !== 'video') return;
          this.mediaView = view;
        },
        toggleOverlayMute(el) {
          const panel = el.closest('.product-media-toggle__panel');
          const video = panel && panel.querySelector('video');
          if (!video) return;
          video.muted = !video.muted;
          this.overlayMuted = video.muted;
        },
        _isToggleRootShown(panel) {
          const root = panel && panel.closest('.product-media-toggle__root');
          if (!root) return false;
          const parent = root.parentElement;
          return !(parent && window.getComputedStyle(parent).display === 'none');
        },
        _pauseGalleryVideos() {
          const gallery = this.$el.querySelectorAll(
            '#x-product-' + settings.section_id + ' video, #stacked-' + settings.section_id + ' video, #x-product-' + settings.section_id + ' .external-video, #stacked-' + settings.section_id + ' .external-video'
          );
          gallery.forEach((el) => {
            if (el.closest('.product-media-toggle__panel')) return;
            if (el.tagName === 'VIDEO') {
              el.pause();
              return;
            }
            if (window.Alpine && Alpine.store('xVideo')) Alpine.store('xVideo').pause(el);
          });
        },
        _pauseTogglePanel(panel) {
          if (!panel) return;
          const video = panel.querySelector('video');
          if (video) video.pause();
        },
        _playTogglePanel(panel) {
          if (!panel || !this._isToggleRootShown(panel)) return;
          const video = panel.querySelector('video');
          if (video) {
            video.muted = this.overlayMuted;
            video.playsInline = true;
            video.loop = true;
            const start = () => {
              video.play().catch(() => {});
            };
            if (video.readyState >= 2) {
              start();
            } else {
              video.addEventListener('canplay', start, { once: true });
              if (video.preload === 'none') video.preload = 'metadata';
              video.load();
            }
          }
          const external = panel.querySelector('[data-toggle-external-video]');
          if (external && window.Alpine && Alpine.store('xVideo')) {
            if (!external.querySelector('iframe')) {
              Alpine.store('xVideo').externalLoad(
                external,
                external.getAttribute('data-video-host'),
                external.getAttribute('data-video-id'),
                true,
                'video-product',
                0
              );
            } else {
              Alpine.store('xVideo').play(external);
            }
          }
        },
        _syncMediaView() {
          const panels = this.$el.querySelectorAll('.product-media-toggle__panel');
          this._pauseGalleryVideos();
          if (this.mediaView === 'photos') {
            panels.forEach((panel) => this._pauseTogglePanel(panel));
            return;
          }
          this.$nextTick(() => {
            requestAnimationFrame(() => {
              panels.forEach((panel) => this._playTogglePanel(panel));
            });
          });
        },
        startZoom(event) {
          const elem = event.currentTarget;
          const size = elem.getBoundingClientRect();
          this.xOffset = size.left;
          this.yOffset = size.top;
          this.imageWidth = size.width;
          this.imageHeight = size.height;
        },
        updatePosition(event) {
          if (this.imageWidth && this.imageHeight) {
            this.xPosition = ((event.clientX - this.xOffset) / this.imageWidth) * 100;
            this.yPosition = ((event.clientY - this.yOffset)  / this.imageHeight) * 100;
          }
        },
        thumbnailHandleMouseDown(e) {
          this.thumbnailOnMouseDown = true;
          this.thumbnailGrabbingClass = 'cursor-grabbing';
          if (settings.thumbnail_direction == 'horizontal') {
            this.thumbnailOfset = e.pageX - this.$refs.thumbnail.offsetLeft;
            this.thumbnailScrollOfset = this.$refs.thumbnail.scrollLeft;
          } else {
            this.thumbnailOfset = e.pageY - this.$refs.thumbnail.offsetTop;
            this.thumbnailScrollOfset = this.$refs.thumbnail.scrollTop;
          }
        },
        thumbnailHandleMouseMove(e) {
          if(!this.thumbnailOnMouseDown) return;
          e.preventDefault();
          if (settings.thumbnail_direction == 'horizontal') {
            const x = e.pageX - this.$refs.thumbnail.offsetLeft;
            const walk = (x - this.thumbnailOfset) * 2; 
            this.$refs.thumbnail.scrollLeft = this.thumbnailScrollOfset - walk;
          }
          else {
            const y = e.pageY - this.$refs.thumbnail.offsetTop;
            const walk = (y - this.thumbnailOfset) * 2; 
            this.$refs.thumbnail.scrollTop = this.thumbnailScrollOfset - walk;
          }
        },
        thumbnailHandleMouseLeave() {
          this._thumbnailRemoveGrabing();
        },
        thumbnailHandleMouseUp() {
          this._thumbnailRemoveGrabing();
        },
        _thumbnailRemoveGrabing() {
          this.thumbnailOnMouseDown = false;
          this.thumbnailGrabbingClass = 'md:cursor-grab';
        },
        zoomOpen(position, isSplide) {
          this.zoomIsOpen = true;
          Alpine.store('xPopup').open = true;
          setTimeout(() => {
            if (isSplide) {
              const splideEl = document.getElementById(`media-gallery-${settings.section_id}`)
              if (splideEl && splideEl.splide) {
                let nextSlideIndex = 0;
                const childrenArray = Array.from(splideEl.querySelector('.splide__list').children)
                childrenArray.map((item, index) => {
                  if (item.getAttribute('x-slide-index') == position) {
                    nextSlideIndex = index
                  }
                })
                splideEl.splide.go(nextSlideIndex);
              }
              document.addEventListener(`eurus:zoom-image-ready:${settings.section_id}`, () => {
                if (splideEl && splideEl.splide) {
                  let nextSlideIndex = 0;
                  const childrenArray = Array.from(splideEl.querySelector('.splide__list').children)
                  childrenArray.map((item, index) => {
                    if (item.getAttribute('x-slide-index') == position) {
                      nextSlideIndex = index
                    }
                  })
                  splideEl.splide.go(nextSlideIndex);
                }
              });
            }
            else {
              document.getElementById(position + '-image-zoom-' + settings.section_id).scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
          }, 200);
          Alpine.store('xModal').activeElement = 'product-image-' + settings.section_id + '-' + position;
        },
        zoomClose() {
          this.zoomIsOpen = false;
          Alpine.store('xPopup').close();
        },
        
        videoHandleIntersect() {
          if (settings.video_autoplay) {
            Alpine.store('xVideo').play(this.$el);
          }
        },
        productModelInit() {
          window.Shopify.loadFeatures([
            {
              name: 'shopify-xr',
              version: '1.0',
              onLoad: this._productModelSetupShopifyXR,
            },
          ]);
        },
        _productModelSetupShopifyXR() {
          const setup = () => {
            document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
              window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
              modelJSON.remove();
            });
            window.ShopifyXR.setupXRElements();
          }
  
          if (!window.ShopifyXR) {
            document.addEventListener('shopify_xr_initialized', () => {
              setup();
            });
            return;
          }
      
          setup();
        },
        productModelLoadMedia() {
          let container = this.$el.parentNode;
          const content = document.createElement('div');
          content.appendChild(container.querySelector('template').content.firstElementChild.cloneNode(true));
  
          this.$el.classList.add('hidden');
          container.appendChild(content.querySelector('model-viewer'));
  
          this._productModelLoadViewerUI();
        },
        productModelPauseViewer() {
          if (this.$el.modelViewerUI) this.$el.modelViewerUI.pause();
        },
        _productModelLoadViewerUI() {
          window.Shopify.loadFeatures([
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: this._productModelSetupViewerUI.bind(this),
            },
          ]);
        },
        _productModelSetupViewerUI(errors) {
          if (errors) return;
  
          this.$el.parentNode.modelViewerUI
            = new Shopify.ModelViewerUI(this.$el.parentNode.querySelector('model-viewer')); 
        }
      }));
    });
  });
}